import { Link } from "react-router-dom";

export default function Download() {
  return (
    <div
      className="bgImage !min-h-[500px] flex flex-col items-center justify-center relative py-10"
      style={{ backgroundImage: `url(/images/home-download.webp)` }}
    >
      <div className="absolute inset-0 bg-[#02122C]/20 z-0" />
      <div className="w-full max-w-[1100px] margins h-full flex items-center gap-16 z-[2]">
        <div className="flex-1 flex flex-col">
          <div className="text-[36px] leading-11 font-bold text-white mb-4">
            Safe, Reliable and Affordable Travel
          </div>
          <div className="max-w-[480px] text-lg text-white">
            Book your tickets today and let Maraliner be your trusted partner in
            discovering the wonders of Malaysia. Your journey begins with us!"
          </div>
        </div>
        <div className="flex flex-col gap-6">
          <div className="flex items-center gap-6">
            <Link to="/">
              <img src="/images/app-store.svg" alt="app store" />
            </Link>
            <div className="bg-[#EFEFEF] p-0.5 rounded-[4px]">
              <img src="/images/qr-app-store.png" alt="" />
            </div>
          </div>
          <div className="flex items-center gap-6">
            <Link to="/">
              <img src="/images/play-store.svg" alt="app store" />
            </Link>
            <div className="bg-[#EFEFEF] p-0.5 rounded-[4px]">
              <img src="/images/qr-play-store.png" alt="" />
            </div>
          </div>
        </div>
      </div>
      <div className="absolute left-0 right-0 bottom-0 bg-primary-700 px-6 py-1.5 text-base font-semibold text-white">
        Book Early to Save Big on Your Next Adventure with Maraliner!"
      </div>
    </div>
  );
}
